import { isValid, parse } from "date-fns";
import { SellingFormValues, ValidationFormErrors, ValidationFormsModeEnum } from "./types";
import { uk } from "date-fns/locale";


export function validateSelling(
  values: SellingFormValues,
  mode: ValidationFormsModeEnum,
  original?: SellingFormValues
): ValidationFormErrors {
  const errors: ValidationFormErrors = {};

  if (!values.name || values.name.trim() === "") {
    errors.name = "Назва обов’язкова.";
  }

  if (!values.client || values.client.trim() === "") {
    errors.client = "Виберіть клієнта.";
  }

  if (!values.responsibleContact || values.responsibleContact.trim() === "") {
    errors.responsibleContact = "Вкажіть відповідальну особу.";
  }

  if (!values.stage || values.stage === "") {
    errors.stage = "Вкажіть етап продажі.";
  }

  if (!values.budget || isNaN(Number(values.budget))) {
    errors.budget = "Введіть коректний бюджет.";
  }

  if (
    !values.deadline ||
    !isValid(
      parse(values.deadline, "d MMMM yyyy", new Date(), {
        locale: uk,
      })
    )
  ) {
    errors.deadline = "Введіть коректну дату.";
  }

  return errors;
}